import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/header_meet.png'
import _imports_1 from '@/assets/img/content_meetix.jpg'
import _imports_2 from '@/assets/img/nav-meetix.png'


const _withScopeId = n => (_pushScopeId("data-v-7c771d9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "custom-header" }
const _hoisted_3 = { class: "label-form" }
const _hoisted_4 = { class: "label-form" }
const _hoisted_5 = { class: "label-form" }
const _hoisted_6 = { class: "label-form" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "label-form" }
const _hoisted_9 = { class: "label-form" }
const _hoisted_10 = { class: "label-form" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "label-form" }
const _hoisted_13 = { class: "label-form" }
const _hoisted_14 = { class: "label-form" }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { class: "label-form" }
const _hoisted_17 = { class: "label-form" }
const _hoisted_18 = { class: "label-form" }
const _hoisted_19 = { class: "label-form" }
const _hoisted_20 = { class: "slider-number" }
const _hoisted_21 = { class: "filter-status-container" }
const _hoisted_22 = { class: "preview-container" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "meetix--img",
  class: "header-img"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "meetix-img",
  class: "content-img"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-txt" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title-preview" }, "15:17 Lundi, 13 Mai 2024"),
  /*#__PURE__*/_createElementVNode("p", { class: "status-txt" }, "DISPONIBLE")
], -1))
const _hoisted_26 = { class: "plus-container" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-txt-bottom" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Reserver maintenant")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "meetix-img",
  class: "navbar-img"
}, null, -1))
const _hoisted_29 = { class: "preview-container" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "meetix--img",
  class: "header-img"
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "meetix-img",
  class: "content-img"
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-txt" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title-preview" }, "15:17 Lundi, 13 Mai 2024"),
  /*#__PURE__*/_createElementVNode("p", { class: "status-txt" }, "PROCHAINE REUINION")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "waiting-container" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-txt-bottom" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title-bottom" }, "COMMENCE DANS"),
  /*#__PURE__*/_createElementVNode("p", { class: "title-bottom-waiting" }, "14 Minutes")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "meetix-img",
  class: "navbar-img"
}, null, -1))
const _hoisted_36 = { class: "preview-container" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "meetix--img",
  class: "header-img"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "meetix-img",
  class: "content-img"
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-txt" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title-preview" }, "15:17 Lundi, 13 Mai 2024"),
  /*#__PURE__*/_createElementVNode("p", { class: "status-txt" }, "OCCUPEE")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "numbers-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "number-txt" }, "59:30")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom-titles" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "bottom-first-title" }, "Réunion en cours"),
  /*#__PURE__*/_createElementVNode("p", { class: "bottom-sub-title-small" }, "13:00 -> 14:00"),
  /*#__PURE__*/_createElementVNode("p", { class: "bottom-sub-title-bold" }, "Board Meeting"),
  /*#__PURE__*/_createElementVNode("p", { class: "bottom-sub-title-small" }, "Achraf Ammar")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "meetix-img",
  class: "navbar-img"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Looder = _resolveComponent("Looder")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_QuestionCircleOutlined = _resolveComponent("QuestionCircleOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_slider = _resolveComponent("a-slider")!
  const _component_a_segmented = _resolveComponent("a-segmented")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Looder, {
      "is-loaded": !_ctx.loading
    }, null, 8, ["is-loaded"]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_breadcrumb, { style: {"margin":"16px 0"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_breadcrumb_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigatePage('/'))),
            class: "breadcrumb-icon"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Meet.Dashboard')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Meet.Settings')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            class: "card-settings",
            "tab-list": _ctx.settingsTitle,
            "active-tab-key": _ctx.key,
            onTabChange: _cache[23] || (_cache[23] = key => _ctx.onTabChange(key, 'key'))
          }, {
            default: _withCtx(() => [
              (_ctx.key === 'notif')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                    _createVNode(_component_a_form, {
                      ref: "formRef",
                      model: _ctx.form,
                      layout: "vertical",
                      class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('Meet.Email')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { name: "url" }, {
                                  label: _withCtx(() => [
                                    _createVNode(_component_a_tooltip, null, {
                                      title: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.url')), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_QuestionCircleOutlined, {
                                          class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                        }, null, 8, ["class"])
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t('Meet.url')), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _ctx.form.emailFeedTxt,
                                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.emailFeedTxt) = $event)),
                                      placeholder: _ctx.t('Meet.url')
                                    }, null, 8, ["value", "placeholder"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              class: "configure-btn-container",
                              span: 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_switch, {
                                  checked: _ctx.sendFeedbackEmails,
                                  "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sendFeedbackEmails) = $event)),
                                  size: "small"
                                }, null, 8, ["checked"]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.t('Meet.receiveFeedbackEmails')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, { class: "checkBox-container" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.checkMailConf,
                              "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkMailConf) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Meet.ConfEmailCheck')), 1)
                              ]),
                              _: 1
                            }, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        (_ctx.checkMailConf===true)
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 0,
                              gutter: 16
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { name: "emailConfirmTxt" }, {
                                      label: _withCtx(() => [
                                        _createVNode(_component_a_tooltip, null, {
                                          title: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('Meet.emailTxtTool')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_QuestionCircleOutlined, {
                                              class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t('Meet.EmailContentConf')), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_textarea, {
                                          value: _ctx.form.emailConfirmTxt,
                                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.emailConfirmTxt) = $event)),
                                          rows: 4,
                                          placeholder: _ctx.t('Meet.EmailContentConf')
                                        }, null, 8, ["value", "placeholder"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_row, { class: "checkBox-container" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.checkMailRes,
                              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkMailRes) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Meet.ResEmailCheck')), 1)
                              ]),
                              _: 1
                            }, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        (_ctx.checkMailRes===true)
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 1,
                              gutter: 16
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { name: "emailTxt" }, {
                                      label: _withCtx(() => [
                                        _createVNode(_component_a_tooltip, null, {
                                          title: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('Meet.emailTxtTool')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_QuestionCircleOutlined, {
                                              class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('Meet.EmailContentMeet')), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_textarea, {
                                          value: _ctx.form.emailConfirmTxt,
                                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.emailConfirmTxt) = $event)),
                                          rows: 4,
                                          placeholder: _ctx.t('Meet.EmailContentMeet')
                                        }, null, 8, ["value", "placeholder"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sendFeedbackEmails)
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 2,
                              class: "checkBox-container"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_checkbox, {
                                  checked: _ctx.checkMailFeed,
                                  "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkMailFeed) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('Meet.feedbackEmailCheck')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["checked"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.checkMailFeed===true && _ctx.sendFeedbackEmails)
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 3,
                              gutter: 16
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { name: "emailConfirmTxt" }, {
                                      label: _withCtx(() => [
                                        _createVNode(_component_a_tooltip, null, {
                                          title: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('Meet.emailTxtTool')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_QuestionCircleOutlined, {
                                              class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('Meet.EmailContentFeed')), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_textarea, {
                                          value: _ctx.form.emailFeedTxt,
                                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.emailFeedTxt) = $event)),
                                          rows: 4,
                                          placeholder: _ctx.t('Meet.EmailContentConf')
                                        }, null, 8, ["value", "placeholder"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_row, { class: "card-footer" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, { type: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('Meet.Update')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  danger: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('Meet.Cancel')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "class"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.key=== 'themes' )
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                    _createVNode(_component_a_form, {
                      ref: "formThemeRef",
                      model: _ctx.formTheme,
                      class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { name: "primaryColor" }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('Meet.PrimaryColor')), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "color",
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formTheme.primaryColor) = $event)),
                                      class: "input-color"
                                    }, null, 512), [
                                      [_vModelText, _ctx.formTheme.primaryColor]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { name: "secondColor" }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('Meet.SecondaryColor')), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "color",
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formTheme.secondColor) = $event)),
                                      class: "input-color"
                                    }, null, 512), [
                                      [_vModelText, _ctx.formTheme.secondColor]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { name: "thirdColor" }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('Meet.ThirdColor')), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "color",
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formTheme.thirdColor) = $event)),
                                      class: "input-color"
                                    }, null, 512), [
                                      [_vModelText, _ctx.formTheme.thirdColor]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, { class: "card-footer" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, { type: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('Meet.Update')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  danger: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('Meet.Cancel')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "class"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.key==='msGraph')
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                    _createVNode(_component_a_form, {
                      ref: "msGraphFormRef",
                      model: _ctx.msGraphForm,
                      rules: _ctx.msExRules,
                      layout: "vertical",
                      class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { name: "clientId" }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('Meet.clientId')), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _ctx.msGraphForm.clientId,
                                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.msGraphForm.clientId) = $event))
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { name: "clientSecret" }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t('Meet.clientSecret')), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input_password, {
                                      value: _ctx.msGraphForm.clientSecret,
                                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.msGraphForm.clientSecret) = $event))
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { name: "tenantId" }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t('Meet.tenantId')), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _ctx.msGraphForm.tenantId,
                                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.msGraphForm.tenantId) = $event))
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, { class: "card-footer" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, { type: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('Meet.Update')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  danger: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('Meet.Cancel')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "rules", "class"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.key === 'theme')
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          xs: { span: 24},
                          sm: { span: 24},
                          md: {span: 10},
                          lg: { span: 10 },
                          xl: { span: 10 },
                          xxl: { span: 10 }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form, {
                              ref: "formThemeRef",
                              model: _ctx.formTheme,
                              layout: "vertical",
                              class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, {
                                      xs: { span: 24},
                                      sm: { span: 24},
                                      md: {span: 12},
                                      lg: { span: 12 },
                                      xl: { span: 12 },
                                      xxl: { span: 12 }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { name: "freeColor" }, {
                                          label: _withCtx(() => [
                                            _createVNode(_component_a_tooltip, null, {
                                              title: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.t('Meet.FreeColorTxt')), 1)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_QuestionCircleOutlined, {
                                                  class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                                }, null, 8, ["class"])
                                              ]),
                                              _: 1
                                            }),
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('Meet.FreeColor')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "color",
                                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formTheme.freeColor) = $event)),
                                              class: "input-color",
                                              onFocus: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleFreeChange && _ctx.handleFreeChange(...args)))
                                            }, null, 544), [
                                              [_vModelText, _ctx.formTheme.freeColor]
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_row, { gutter: 16 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, {
                                      xs: { span: 24},
                                      sm: { span: 24},
                                      md: {span: 12},
                                      lg: { span: 12 },
                                      xl: { span: 12 },
                                      xxl: { span: 12 }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { name: "waitingColor" }, {
                                          label: _withCtx(() => [
                                            _createVNode(_component_a_tooltip, null, {
                                              title: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.t('Meet.WaitingColorTxt')), 1)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_QuestionCircleOutlined, {
                                                  class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                                }, null, 8, ["class"])
                                              ]),
                                              _: 1
                                            }),
                                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t('Meet.WaitingColor')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "color",
                                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formTheme.waitingColor) = $event)),
                                              class: "input-color",
                                              onFocus: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleWaitingChange && _ctx.handleWaitingChange(...args)))
                                            }, null, 544), [
                                              [_vModelText, _ctx.formTheme.waitingColor]
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, {
                                      xs: { span: 24},
                                      sm: { span: 24},
                                      md: {span: 12},
                                      lg: { span: 12 },
                                      xl: { span: 12 },
                                      xxl: { span: 12 }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { name: "bookedColor" }, {
                                          label: _withCtx(() => [
                                            _createVNode(_component_a_tooltip, null, {
                                              title: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.t('Meet.BookedColorTxt')), 1)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_QuestionCircleOutlined, {
                                                  class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                                }, null, 8, ["class"])
                                              ]),
                                              _: 1
                                            }),
                                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t('Meet.BookerColor')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "color",
                                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formTheme.bookedColor) = $event)),
                                              class: "input-color",
                                              onFocus: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.handleBookedChange && _ctx.handleBookedChange(...args)))
                                            }, null, 544), [
                                              [_vModelText, _ctx.formTheme.bookedColor]
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, {
                                      xs: { span: 24},
                                      sm: { span: 24},
                                      md: {span: 12},
                                      lg: { span: 12 },
                                      xl: { span: 12 },
                                      xxl: { span: 12 }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { name: "opacity" }, {
                                          label: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.t('Meet.ColorOpacity')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { class: "slider-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 20 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_slider, {
                                                      value: _ctx.formTheme.opacity,
                                                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formTheme.opacity) = $event)),
                                                      class: "slider-input",
                                                      onAfterChange: _ctx.handleOpacityChange
                                                    }, null, 8, ["value", "onAfterChange"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 4 }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formTheme.opacity), 1)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["model", "class"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: { span: 24},
                          sm: { span: 24},
                          md: {span: 14},
                          lg: { span: 14 },
                          xl: { span: 14 },
                          xxl: { span: 14 }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_a_segmented, {
                                value: _ctx.activeTab,
                                "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.activeTab) = $event)),
                                options: _ctx.tabList
                              }, null, 8, ["value", "options"])
                            ]),
                            (_ctx.activeTab === _ctx.t('Meet.Free') )
                              ? (_openBlock(), _createBlock(_component_a_card, {
                                  key: 0,
                                  hoverable: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_22, [
                                      _createVNode(_component_a_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, {
                                            xs: { span: 24},
                                            sm: { span: 24},
                                            md: {span: 24},
                                            lg: { span: 24 },
                                            xl: { span: 24 },
                                            xxl: { span: 24 },
                                            class: "header-container"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_23
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, {
                                            xs: { span: 24},
                                            sm: { span: 24},
                                            md: {span: 14},
                                            lg: { span: 14 },
                                            xl: { span: 14 },
                                            xxl: { span: 14 },
                                            class: "content-container"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_24,
                                              _createElementVNode("span", {
                                                class: "color-span",
                                                style: _normalizeStyle({ backgroundColor: _ctx.formTheme.freeColor, opacity:_ctx.formTheme.opacity/100 })
                                              }, null, 4),
                                              _hoisted_25,
                                              _createElementVNode("div", _hoisted_26, [
                                                _createVNode(_component_PlusOutlined, { class: "plus-icon" })
                                              ]),
                                              _hoisted_27
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_col, {
                                            xs: { span: 24},
                                            sm: { span: 24},
                                            md: {span: 10},
                                            lg: { span: 10 },
                                            xl: { span: 10 },
                                            xxl: { span: 10 },
                                            class: "navbar-container"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_28
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.activeTab === _ctx.t('Meet.Waiting') )
                              ? (_openBlock(), _createBlock(_component_a_card, {
                                  key: 1,
                                  hoverable: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createVNode(_component_a_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, {
                                            span: 24,
                                            class: "header-container"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_30
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, {
                                            span: 14,
                                            class: "content-container"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_31,
                                              _createElementVNode("span", {
                                                class: "color-span",
                                                style: _normalizeStyle({ backgroundColor: _ctx.formTheme.waitingColor, opacity:_ctx.formTheme.opacity/100 })
                                              }, null, 4),
                                              _hoisted_32,
                                              _hoisted_33,
                                              _hoisted_34
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_col, {
                                            span: 10,
                                            class: "navbar-container"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_35
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.activeTab === _ctx.t('Meet.Booked') )
                              ? (_openBlock(), _createBlock(_component_a_card, {
                                  key: 2,
                                  hoverable: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_36, [
                                      _createVNode(_component_a_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, {
                                            span: 24,
                                            class: "header-container"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_37
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, {
                                            span: 14,
                                            class: "content-container"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_38,
                                              _createElementVNode("span", {
                                                class: "color-span",
                                                style: _normalizeStyle({ backgroundColor: _ctx.formTheme.bookedColor, opacity:_ctx.formTheme.opacity/100 })
                                              }, null, 4),
                                              _hoisted_39,
                                              _hoisted_40,
                                              _createVNode(_component_a_row, {
                                                gutter: 16,
                                                class: "title-txt-bottom-booked"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_col, { span: 16 }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_41
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_a_col, {
                                                    span: 8,
                                                    class: "user-icon-container"
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_col, {
                                            span: 10,
                                            class: "navbar-container"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_42
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, { class: "card-footer" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, { type: "primary" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Meet.Update')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_button, {
                              type: "primary",
                              danger: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Meet.Cancel')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["tab-list", "active-tab-key"])
        ]),
        _: 1
      })
    ])
  ], 64))
}